/**
 * Přišla látka na roli, nebo přeložená na půl? Používá se při příjmu
 * (před potvrzením) i v detailu role (oprava překliku).
 */
export function FormaSwitch({
  value,
  onChange,
  disabled,
}: {
  /** true = složené, false = role. */
  value: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}) {
  const base =
    'px-3 py-1.5 text-sm font-semibold cursor-pointer transition-colors disabled:opacity-50';
  const on = 'bg-primary text-white';
  const off = 'bg-surface text-text-secondary hover:bg-surface-hover';
  return (
    <div className="inline-flex rounded-lg border border-border overflow-hidden">
      <button
        type="button"
        onClick={() => onChange(false)}
        disabled={disabled}
        className={`${base} ${value ? off : on}`}
      >
        Role
      </button>
      <button
        type="button"
        onClick={() => onChange(true)}
        disabled={disabled}
        className={`${base} border-l border-border ${value ? on : off}`}
      >
        Složené
      </button>
    </div>
  );
}
